/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
'use strict';
import { registerLanguage } from '../_.contribution.js';
registerLanguage({
    id: 'swift',
    aliases: ['Swift', 'swift'],
    extensions: ['.swift'],
    mimetypes: ['text/swift'],
    loader: function () { return import('./swift.js'); }
});
